export function WaitingForSignal() {
  return (
    <div className="term-text" style={{ padding: 'var(--space-2)' }} role="status">
      <div className="term-line term-line--amber">&gt; תנאי ההעברה התקיים.</div>
      <div className="term-line term-line--amber">&gt; ממתין לאות (אין חיבור לרשת)...</div>
      <div className="term-line term-line--system">&gt; הפענוח יושלם אוטומטית כשהחיבור יחזור.</div>
      <div className="term-line">
        <span className="term-cursor" aria-hidden="true" />
      </div>
    </div>
  );
}
